import { colors } from '../../colors'

interface CharacterCounterProps {
  currentLength: number
  maxLength: number
  className?: string
}

const styles: Record<string, React.CSSProperties> = {
  counter: {
    fontSize: '12px',
    color: colors['text-secondary'],
    textAlign: 'right',
  },
}

const CharacterCounter: React.FC<CharacterCounterProps> = ({
  currentLength,
  maxLength,
  className,
}) => {
  return (
    <div style={styles.counter} className={className}>
      {currentLength}/{maxLength}
    </div>
  )
}

export default CharacterCounter
